import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class SucursalesService {

  private service_url;
  constructor(private constantsService: ConstantsService, private http: Http, private authService: AutenticacionService, private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/sucursales';
  }

  public validate(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["nombre"], 200)){
      error["nombre"] = this.errorService.max(200);
    }

    if(!this.validatorService.required(data["ciudad"])){
      error["ciudad"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["ciudad"], 200)){
      error["ciudad"] = this.errorService.max(200);
    }

    if(!this.validatorService.required(data["direccion"])){
      error["direccion"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["direccion"], 200)){
      error["direccion"] = this.errorService.max(200);
    }

    return error;
  }

  getDefaultSchedule() {
    return {
      'id': '',
      'nombre': '',
      'descripcion': '',
      'direccion': '',
      'telefono': ''
    };
  }

  get(page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  public getSelect() {
    return this.http.get(this.service_url + '?select=true', this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  search(search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  create(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  update(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  delete(id) {
    return this.http.delete(this.service_url + '?id=' + id, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/sucursales.service.ts